<template>
  <article v-if="spinLoading" class>
    <overlay :transparentBg="false" />
    <div class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20">
      <section class="container">
        <section class="centerCss">
          <Vue3Lottie :animationData="LoaderNormal" :speed="1" :loop="true" :height="isMobile ? 175 : 220"
            :width="isMobile ? 175 : 220" />
          <div class="textSection">
            <div class="textCss text-base text-textSecondary">
              <div class="spinner">
                {{ textSpinner }} <br /> {{ subTextSpinner }}
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div>
              <p v-if="secondaryText" class="label-text-medium">{{ secondaryText }}</p>
            </div>
          </div>
        </section>
      </section>
    </div>
  </article>
</template>
<script>
import { mapGetters } from 'vuex';
import Overlay from './Overlay.vue';
import LoaderNormal from '../assets/animation/Loader_normal.json';

export default {
  name: 'Credit Statement',
  components: { Overlay },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters(['creditAccountInfo']),
  },
  props: {
    spinLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    textSpinner: {
      type: Text,
      required: true,
      default: 'Please wait while we fetch',
    },
    subTextSpinner: {
      type: Text,
      required: true,
      default: 'your details',
    },
    secondaryText: {
      type: Text,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      LoaderNormal,
      isLoading: false,
      isMobile: false,
      creditStatementData: undefined
    };
  },
  methods: {
    init() {
      this.isMobile = window.innerWidth <= 768; // set the breakpoint for mobile devices
    },
  }
};
</script>
<style lang="scss" scoped>
 .loader {
    border: 8px solid #F3F3F3;
    border-radius: 50%;
    border-top: 8px solid #006295;
    width: 50px;
    height: 50px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }
  /* Safari */
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .textCss{
    font-family: 'Myriad Pro';
    font-style: normal;
    font-weight: 400;
    text-align: center;
    padding-top: 0.5rem;
  }
  /*Huge thanks to @tobiasahlin at http://tobiasahlin.com/spinkit/ */

.spinner > div {
  width: 4px;
  height: 4px;
  background-color: #041D28;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
.textSection{
  display: flex;
  width: max-content;
}
.container{
  display: grid;
  justify-items: center;
  position: relative;
  font-family: 'Myriad Pro';
}
.centerCss{
  top: 50%;
  display: grid;
  justify-items: center;
}
.iconSection{
  display: flex;
  margin-left: -25px;
}
.icon{
  margin-top: 15px;
  margin-left: -38px;
}
</style>
